var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"component thumbnail",attrs:{"src":!_vm.imageChanged && _vm.defaultImage ? _vm.defaultImage : _vm.imageUrl,"alt":"thumbnail"}})}
var staticRenderFns = []

export { render, staticRenderFns }